<div *ngIf="message.length < 1">
    <mat-spinner></mat-spinner>
</div>

<h2>{{ message }}</h2>